export default __webpack_public_path__ + "static/media/seat.28ef6ca7.svg";